import Icon from '../components/Icon.vue'

Icon.register({"car-alt":{"width":480,"height":512,"paths":[{"d":"M438.7 212.3L427.4 184.2 407.5 134.4C390.4 91.6 349.6 64 303.5 64H176.5C130.4 64 89.6 91.6 72.5 134.4L52.6 184.2 41.3 212.3C17.2 221.5 0 244.7 0 272V320C0 336.1 6.2 350.7 16 361.9V416C16 433.7 30.3 448 48 448H80C97.7 448 112 433.7 112 416V384H368V416C368 433.7 382.3 448 400 448H432C449.7 448 464 433.7 464 416V361.9C473.8 350.7 480 336.1 480 320V272C480 244.7 462.8 221.5 438.7 212.3zM131.9 158.2C139.2 139.9 156.9 128 176.5 128H303.5C323.1 128 340.8 139.9 348.1 158.2L368 208H112L131.9 158.2zM80 319.8C60.8 319.8 48 307 48 287.9S60.8 256 80 256 128 284.7 128 303.9 99.2 319.8 80 319.8zM400 319.8C380.8 319.8 352 323 352 303.9S380.8 256 400 256 432 268.8 432 287.9 419.2 319.8 400 319.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/car-alt.js
// module id = null
// module chunks = 